import { IngestFileType } from "../../common/domain/IngestFileType";
import { Config } from "../../config";

export const fileTypesMap: {[key:string]:IngestFileType} = {
    'FixedIncome': {
        id: 'BEP',
        name: 'Fixed Income',
        internalId: 'BEP',
        internalType:'BEP'
    },
    'Spot': {
        id:'FEP_SPOT',
        name: 'Spot',
        internalId: 'FEP_SPOT',
        internalType: 'FEP_SPOT'
    },
    'Forwards': {
        id:'FEP_LINEAR',
        name: 'Forwards',
        internalId: 'FEP_LINEAR',
        internalType: 'FEP_LINEAR'
    },
    'Options': {
        id: 'FEP_NONLINEAR',
        name: 'Options',
        internalId: 'FEP_NONLINEAR',
        internalType: 'FEP_NONLINEAR'
    },
    'InterestRateSwaps': {
        id: 'REP_LINEAR',
        name: 'Interest Rate Swaps',
        internalId: 'REP_LINEAR',
        internalType: 'REP_LINEAR'
    }
};

export const getActiveFileTypes = (config: Config) : Array<IngestFileType> => {
    const fileTypes: Array<IngestFileType> = [];

    if (config.bepActiveFlag) {
        fileTypes.push(fileTypesMap.FixedIncome);
    }
    
    if (config.fepSpotActiveFlag) {
        fileTypes.push(fileTypesMap.Spot);
    }
    
    if (config.fepForwardsActiveFlag) {
        fileTypes.push(fileTypesMap.Forwards);
    }
    
    if (config.fepNonLinearActiveFlag) {
        fileTypes.push(fileTypesMap.Options);
    }

    if (config.repLinearActiveFlag) {
        fileTypes.push(fileTypesMap.InterestRateSwaps);
    }
    
    return fileTypes;
};